import { render, staticRenderFns } from "./OrderProductList.vue?vue&type=template&id=3af9f46e&"
import script from "./OrderProductList.vue?vue&type=script&lang=js&"
export * from "./OrderProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports